import { render, staticRenderFns } from "./MockExam.vue?vue&type=template&id=f2ecab2e&"
import script from "./mockExam.js?vue&type=script&lang=js&"
export * from "./mockExam.js?vue&type=script&lang=js&"
import style0 from "./mockExam.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports